
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace-management/lineage",
      function () {
        return require("private-next-pages/workspace-management/lineage.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workspace-management/lineage"])
      });
    }
  